import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NumberRegEx } from '../constants/validation-regex';

export const numberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return NumberRegEx.test(control.value) ? null : { number: true };
};
